import { AssetDTO, FormType } from '@gearbelt/global';
import { match } from 'ts-pattern';

import { cn } from '@/lib/utils';

import WarningIcon from '../icons/warning';
import { badgeVariants } from '../ui/badge';

export function FormBadge({
  form,
  className,
  disabled = false,
  truncate = false,
}: {
  form: NonNullable<AssetDTO['forms']>[number];
  className?: string;
  disabled?: boolean;
  truncate?: boolean;
}) {
  const badgeClasses = disabled
    ? 'bg-grey-1 text-default-text'
    : match(form.type)
        .with(FormType.InspectionForm, () => 'bg-default-light-blue text-default-dark-blue hover:bg-default-light-blue/80')
        .with(FormType.RepairForm, () => 'bg-default-light-orange text-default-dark-orange hover:bg-default-light-orange/80')
        .with(FormType.ScheduleForm, () => 'bg-default-light-green text-default-dark-green hover:bg-default-light-green/80')
        .otherwise(() => 'bg-grey-2 text-grey-8');

  return (
    <span className={cn(badgeVariants(), badgeClasses, truncate && 'max-w-full truncate', className)} key={form.id}>
      {disabled && <WarningIcon className="text-default-red shrink-0" />}
      {truncate ? <span className="truncate">{form.name}</span> : form.name}
    </span>
  );
}
